import { useState, useEffect } from 'react';
import Hamburger from './hamburger.jsx'
import './Topbar.css';

const Topbar = () => {
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if the token exists in localStorage or any other authentication state
    // Update the value of isLoggedIn based on the authentication status
    // For example, you can use a token stored in localStorage as a simple check
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
  }, []);

  const toggleHamburger = () => {
    setHamburgerOpen(!hamburgerOpen);
  };

  return (
    <div className='top'>
      <div className='topbar-Container'>
        <div className='top-left'>
          <img src='./ghabsalogo.png' alt='ghabsalogo' width='178px' height='104px' />
          <div className='orgo-title'>
            <span className='orgo-acronym'>GHABSA</span>
            <span className='orgo-full'>GHANA BIOCHEMISTRY STUDENTS' ASSOCIATION</span>
          </div>
        </div>

        <div className='Login'>
          {isLoggedIn ? (
            // Render nothing if user is logged in
            null
          ) : (
            // Render the login button if user is not logged in
            <span className='Login-bt'>
              <a href='/Login'>Login</a>
            </span>
          )}
        </div>

        <div className='Nav-list-a'>
          <ul className='top-right-bottom'>
          <li className='top-right-bottom-li'>
              <a href='/'>
                Home
              </a>
            </li>
            <li className='top-right-bottom-li'>
              <a href='/'>
                <i className='fa-solid fa-books'></i>
              </a>
            </li>
            <li className='top-right-bottom-li'>
              <a href='/'>About us</a>
            </li>
            <li className='top-right-bottom-li'>
              <a href='/'>Contact support</a>
            </li>
          </ul>
          <div className='Hamburger' onClick={toggleHamburger}>
            <Hamburger isOpen={hamburgerOpen} />
          </div>
        </div>
      </div>

      
      <style jsx="true">{`
          .Nav-list-a{
            display: flex;
            align-items: center;
            position: relative;
            top:50%;
            height:50%;
            color:black;
            width:35%;
            padding-right: 0.25em;
           
        }

        
        .Nav-list-a .top-right-bottom{
            display: flex;
            flex-direction: row;
            list-style: none;
            padding: 0.25em;
           
          }
          .top-right-bottom li a{
            content:" ";
            width:0;
            text-decoration:none;
            color:black;
            font-weight:600;
            font-family: 'Source Sans Pro', sans-serif;
            transition:width 0.3s ease;
          }
          .top-right-bottom li a::after:hover{
            cursor:pointer;
            margin-bottom:0.15em;
            border-bottom:1px solid #fff;
            color:#071D2B;
            font-weight:500;

          }
         
        

          @media (max-width:767px){
          
            .Nav-list-a{
              width:100%;
              height:200%;
              display:flex;
              flex-direction:column;
              margin-right:0;
              padding-right:0;
              z-index:10;
              margin:0;
              padding:0;
              
            }
            .Nav-list-a .top-right-bottom{
              display:${hamburgerOpen ? 'flex' : 'none'};
              background-color: #000;
              width:100%;
              position:absolute;
              right:0;
              flex-direction:column;
              justify-content:flex-start;
              height:100%;
              width:100vw;
              align-items:center;
              padding-right:2em;
    
              margin-top:3.75em;
              color:black;
              font-size:1rem;
              font-weight:500;
              opacity:0.9;
              z-index:10;
            
            }
            .top-right-bottom li {
              text-align:center;
              width:100%;
              color:#071D2B;
              padding:0.25em 0.5em;
              margin-bottom:0.15em;
              border-radius:8px;
            }
            .top-right-bottom li a{
        
              color:#071D2B;
              padding:0.25em 0.5em;
              margin-bottom:0.25em;
              border-radius:8px;
            }
            .top-right-bottom li :last-child{
              margin-bottom:0;
            }
            .top-right-bottom li a:hover{
              cursor:pointer;
              color:white;
              width:50%;
              background-color:gray;
              padding:0.25em 0.5em;
              border-radius:8px;
            }
            
          }
          `}</style>
             
    </div>
  );
};

export default Topbar;
